<template>
  <v-row justify="center">
    <v-col xl="10">
      <v-card>
        <v-card-title>
          <h2>{{ $t("admin.teams.title") }}</h2>
          <v-btn :icon="$vuetify.breakpoint.smAndDown" @click="create()" class="ml-5" color="primary" text>
            <v-icon left>mdi-account-multiple-plus-outline</v-icon>
            <span class="hidden-sm-and-down">{{ $t("admin.teams.actions.add") }}</span>
          </v-btn>
          <v-card> </v-card>
          <v-spacer></v-spacer>
          <v-text-field
            :label="$t('admin.teams.actions.search')"
            append-icon="mdi-magnify"
            hide-details
            single-line
            v-model="search"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :options.sync="pagination"
          :server-items-length="totalItems"
          class="elevation-1"
          item-key="id"
        >
          <template v-slot:item.controls="props">
            <v-btn raised color="primary" :to="`/admin/team/${props.item.id}/activities`">
              {{ $t("admin.teams.actions.manage") }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import debounce from "../../../util/debounce";

export default {
  data() {
    return {
      valid: false,
      totalItems: 0,
      items: [],
      loading: true,
      pagination: {
        itemsPerPage: 25,
      },
      search: "",
      headers: [
        { text: this.$t("admin.teams.list.name"), value: "name" },
        {
          text: this.$t("admin.teams.list.slug"),
          value: "slug",
          sortable: false,
        },
        {
          text: this.$t("admin.teams.list.actions"),
          value: "controls",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.getDataFromApi();
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    search: {
      handler() {
        debounce(this.getDataFromApi);
      },
      deep: true,
    },
  },
  methods: {
    create() {
      this.$router.push({ name: `teamCreate` });
    },
    async getDataFromApi() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      this.loading = true;
      const result = await axios.get("/event/teams", {
        params: {
          eventId: this.$route.params.eventId,
          page: page - 1,
          size: itemsPerPage,
          sortBy: sortBy.join(","),
          sortOrder: sortDesc.map((s) => (s ? "desc" : "asc")).join(","),
          search: this.search || undefined,
        },
      });
      this.items = result.rows;
      this.totalItems = result.count;
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
